module.exports = __webpack_public_path__ + "static/media/Telus_One_page-29.a8a346f2.png";